import { render } from "./role-creator.vue?vue&type=template&id=35e5617a&lang=pug"
import script from "./role-creator.vue?vue&type=script&setup=true&lang=js"
export * from "./role-creator.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__